import { render, staticRenderFns } from "./WorklistOverview.vue?vue&type=template&id=35c63ce6&scoped=true&"
import script from "./WorklistOverview.vue?vue&type=script&lang=ts&"
export * from "./WorklistOverview.vue?vue&type=script&lang=ts&"
import style0 from "./WorklistOverview.vue?vue&type=style&index=0&id=35c63ce6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c63ce6",
  null
  
)

export default component.exports